/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FroalaImageResponse } from '../../models/froala-image-response';

export interface ImageUpload$Params {

/**
 * Type of field in entity from which is image uploaded.
 */
  entityFieldName: 'PROFILE_DESCRIPTION' | 'PROFILE_VISION' | 'ACTIVITY_DESCRIPTION' | 'USER_DESCRIPTION' | 'SEND_IDEA' | 'ESG';

/**
 * Id of entity from which is image uploaded.
 */
  entityId: number;
      body: {
'file': Blob;
}
}

export function imageUpload(http: HttpClient, rootUrl: string, params: ImageUpload$Params, context?: HttpContext): Observable<StrictHttpResponse<FroalaImageResponse>> {
  const rb = new RequestBuilder(rootUrl, imageUpload.PATH, 'post');
  if (params) {
    rb.path('entityFieldName', params.entityFieldName, {});
    rb.path('entityId', params.entityId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FroalaImageResponse>;
    })
  );
}

imageUpload.PATH = '/rest/froala/image-upload/{entityFieldName}/{entityId}';
